import React from "react";
import '../../../styles/components/onboarding/info/songs-page.scss';
import {onboardingImagesSource} from "../../../config/config";
import {WhenDeviceTypeDesktop} from "../../conditional/device/type/WhenDeviceTypeDesktop";
import {DynamicImage} from "../../common/DynamicImage";
export default function SongsPage() {
  return (
    <div className="songs-page">
      <WhenDeviceTypeDesktop>
        <DynamicImage pngSrc={onboardingImagesSource.albumsPNG} webpSrc={onboardingImagesSource.albumsWEBP} width={816} height={672} additionalClassName={'slide-image slide-center'} />
      </WhenDeviceTypeDesktop>
      <WhenDeviceTypeDesktop not>
        <header className="top">
          <DynamicImage pngSrc={onboardingImagesSource.albumsPNG} webpSrc={onboardingImagesSource.albumsWEBP} width={816} height={672} additionalClassName={'albums-image'} alt={'Selected Playground songs'} />
        </header>
      </WhenDeviceTypeDesktop>
      <div className="content">
        <div className="content-header">Learn to play the songs you&nbsp;love</div>
        <div className="info-text">Pick your favorites out of our growing collection of over 2,000 songs and start playing. Rookie, Intermediate, and Advanced song levels arranged for you.</div>
      </div>
    </div>
  );
}